import React, { Component } from 'react';
import Alert from 'react-bootstrap/Alert';

class MediaUpload extends Component {
    constructor(props) {
        super(props);
        this.state = {
            previewUrl: props.value || "",
            file: null
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
            this.setState({ previewUrl: this.props.value || "", file: null });
        }
    }

    handleFileChange = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        let previewUrl = "";
        if (this.props.accept.includes("image")) {
            previewUrl = URL.createObjectURL(file);
        } else if (this.props.accept.includes("video")) {
            previewUrl = URL.createObjectURL(file);
        }

        this.setState({ previewUrl, file });
        
        if (this.props.onChange) {
            this.props.onChange(event);
        }
    }

    render() {
        const { label, accept, error, maxWidth = "100%", maxHeight = "auto", buttonPosition = "bottom" } = this.props;
        const { previewUrl } = this.state;
        const isImage = accept.includes("image");
        const isVideo = accept.includes("video");
        
        const buttonText = previewUrl 
            ? (isImage ? "Cambiar imagen" : "Cambiar video")
            : (isImage ? "Subir imagen" : "Subir video");

        const isInline = buttonPosition === "right" && previewUrl;

        const buttonElement = (
            <label className="btn btn-primary" style={{ cursor: 'pointer', marginBottom: 0, ...(isInline ? {} : { display: 'block' }) }}>
                {buttonText}
                <input 
                    name={this.props.name}
                    onChange={this.handleFileChange} 
                    type="file" 
                    className="d-none" 
                    accept={accept} 
                />
            </label>
        );

        return (
            <div className="form-group">
                <label>{label}</label>
                {previewUrl ? (
                    <div style={{ display: isInline ? 'flex' : 'block', alignItems: isInline ? 'flex-start' : 'center', gap: isInline ? '1rem' : '0' }}>
                        <div className={isInline ? "" : "mb-2"} style={{ maxWidth, height: maxHeight, overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                            {isImage && (
                                <img 
                                    className="img-fluid preview" 
                                    src={previewUrl} 
                                    alt="Preview" 
                                    style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                                />
                            )}
                            {isVideo && (
                                <video 
                                    controls 
                                    src={previewUrl} 
                                    type="video/mp4"
                                    style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                                />
                            )}
                        </div>
                        {isInline && buttonElement}
                    </div>
                ) : (
                    buttonElement
                )}
                {previewUrl && !isInline && buttonElement}
                <Alert show={!!error} className="mt-2" variant="danger">{error}</Alert>
                {this.props.helpText && (
                    <small className="form-text text-muted">{this.props.helpText}</small>
                )}
            </div>
        );
    }
}

export default MediaUpload;
